var map = {
	"./eon_reality.png": "./app/assets/images/business/partners/eon_reality.png",
	"./microsoft.png": "./app/assets/images/business/partners/microsoft.png",
	"./nike.png": "./app/assets/images/business/partners/nike.png",
	"./nvidia.png": "./app/assets/images/business/partners/nvidia.png",
	"./petco.png": "./app/assets/images/business/partners/petco.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/business/partners sync recursive ^\\.\\/.*\\.png$";